import React from 'react';

import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';

const FIELD_STYLES = {
  default: '',
  ghost: 'min-h-20 resize-none border-none px-0 shadow-none focus-visible:ring-0',
};

const TextareaField = ({
  control,
  name,
  label = '',
  placeholder = '',
  variant = 'default',
}) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem>
        {!isEmpty(label) && <FormLabel>{label}</FormLabel>}

        <FormControl>
          <Textarea
            {...field}
            className={FIELD_STYLES[variant]}
            placeholder={placeholder}
          />
        </FormControl>

        <FormMessage />
      </FormItem>
    )}
  />
);

TextareaField.propTypes = {
  control: PropTypes.shape({}).isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'ghost']),
};

export default TextareaField;
